import styled from 'styled-components';

export const PriceTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    font-size: ${props => props.theme.text.size.small};

    tbody tr[data-active]:hover {
        background: ${props => props.theme.colors.subtle.light};
    }

    /* An active method carries an accent bar; an inactive one steps back, so the state reads at a glance. */
    tbody tr[data-active='true'] {
        box-shadow: inset 0.3rem 0 0 0 ${props => props.theme.colors.primary};
    }

    tbody tr[data-active='false'] {
        color: ${props => props.theme.colors.text.subtleSecondary};
    }

    /* A row edited since the list was loaded is tinted until it is saved. */
    tbody tr[data-changed='true'],
    tbody tr[data-changed='true']:hover {
        background: ${props => props.theme.colors.table.modifiedRow};
    }
`;

/** Which market and segment the table prices, since the filters above serve every table. */
export const TableHeading = styled.h3`
    margin: 2rem 0 0;
    font-family: ${props => props.theme.text.font.medium};
    font-size: ${props => props.theme.text.size.medium};
`;

export const Th = styled.th<{ $numeric?: boolean }>`
    padding: 0.6rem 0.8rem;
    text-align: ${props => (props.$numeric ? 'right' : 'left')};
    font-family: ${props => props.theme.text.font.medium};
    color: ${props => props.theme.colors.text.secondary};
    border-bottom: 0.1rem solid ${props => props.theme.colors.border};
    white-space: nowrap;
`;

export const Td = styled.td<{ $numeric?: boolean }>`
    padding: 0.4rem 0.8rem;
    text-align: ${props => (props.$numeric ? 'right' : 'left')};
    border-bottom: 0.1rem solid ${props => props.theme.colors.border};
    vertical-align: middle;
    white-space: nowrap;
`;

export const GroupHeaderCell = styled.td`
    padding: 1.2rem 0.8rem 0.6rem;
    font-family: ${props => props.theme.text.font.medium};
    color: ${props => props.theme.colors.text.secondary};
    background: ${props => props.theme.colors.subtle.light};
    border-bottom: 0.1rem solid ${props => props.theme.colors.border};
`;

export const Dash = styled.span`
    color: ${props => props.theme.colors.text.subtleSecondary};
`;
